module.exports = __webpack_public_path__ + "img/adver.c58b744f.png";